import axiosInstance from "../../axiosInstance";

const BASE_URL = "/reports/hrm/tasks";

/* =========================================================
📌 1) TẠO BÁO CÁO (generate report + PDF + GCS)
   POST /api/hrm/task-reports/generate
========================================================= */
export const generateTaskReport = async (payload) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/generate`, payload);
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể tạo báo cáo";
    console.error("❌ generateTaskReport error:", msg, error);
    throw new Error(msg);
  }
};

/* =========================================================
📌 2) LẤY DANH SÁCH BÁO CÁO
   GET /api/hrm/task-reports
========================================================= */
export const getTaskReports = async (filters = {}) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/`, { params: filters });
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể tải danh sách báo cáo";
    console.error("❌ getTaskReports error:", msg, error);
    throw new Error(msg);
  }
};

/* =========================================================
📌 3) LẤY CHI TIẾT 1 BÁO CÁO
   GET /api/hrm/task-reports/detail/:id
========================================================= */
export const getTaskReportDetail = async (id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/detail/${id}`);
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể tải chi tiết báo cáo";
    console.error("❌ getTaskReportDetail error:", msg, error);
    throw new Error(msg);
  }
};

/* =========================================================
📌 4) DUYỆT / ĐÁNH GIÁ BÁO CÁO
   PUT /api/hrm/task-reports/review/:id
========================================================= */
export const reviewTaskReport = async (id, data) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/review/${id}`, data);
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể duyệt báo cáo";
    console.error("❌ reviewTaskReport error:", msg, error);
    throw new Error(msg);
  }
};

/* =========================================================
📌 5) XÓA BÁO CÁO
   DELETE /api/hrm/task-reports/:id
========================================================= */
export const deleteTaskReport = async (id) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    const msg = error?.response?.data?.message || "Không thể xóa báo cáo";
    console.error("❌ deleteTaskReport error:", msg, error);
    throw new Error(msg);
  }
};

/* =========================================================
📌 6) AI tóm tắt qua backend proxy (HF)
   POST /api/ai/summarize/huggingface
========================================================= */
export const summarizeTaskReportByHfProxy = async (text, maxWords = 100) => {
  try {
    const res = await axiosInstance.post("/ai/summarize/huggingface", {
      text,
      max_words: maxWords,
    });
    return res.data;
  } catch (error) {
    const status = error?.response?.status || null;
    const message = error?.response?.data?.message || error?.message || "Không thể tóm tắt bằng HuggingFace";
    const e = new Error(message);
    e.status = status;
    throw e;
  }
};

/* =========================================================
📌 7) AI tóm tắt qua backend proxy (Gemini)
   POST /api/ai/summarize/gemini
========================================================= */
export const summarizeTaskReportByGeminiProxy = async (text, maxWords = 100) => {
  try {
    const res = await axiosInstance.post("/ai/summarize/gemini", {
      text,
      max_words: maxWords,
    });
    return res.data;
  } catch (error) {
    const status = error?.response?.status || null;
    const message = error?.response?.data?.message || error?.message || "Không thể tóm tắt bằng Gemini";
    const e = new Error(message);
    e.status = status;
    throw e;
  }
};
